import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBrush = () => {
  return (
    <g>
      <path d="m15.45 1.7785a2.017 2.017 0 0 0 -2.8184.166l-7.2196 7.1743a3.03 3.03 0 0 0 -1.2645.3658c-.3232.1807-.6318.3867-.9395.5928-.2217.1484-.4434.2978-.6728.4346a2.78 2.78 0 0 1 -1.6768.5156.75.75 0 0 0 -.6631 1.2139 7.22 7.22 0 0 0 1.9756 1.7725 4.9041 4.9041 0 0 0 2.4795.7109c.0693 0 .1387-.001.208-.0049a3.7971 3.7971 0 0 0 2.6367-1.21 3.0057 3.0057 0 0 0 .7539-1.6658l7.0664-7.29a1.949 1.949 0 0 0 .1346-2.7757zm-9.07 10.7276a2.3227 2.3227 0 0 1 -1.5947.7158 3.4039 3.4039 0 0 1 -1.8535-.501 4.7472 4.7472 0 0 1 -.6182-.4355 6.0144 6.0144 0 0 0 .9922-.4863c.251-.15.4941-.3125.7373-.4756.2744-.1836.5488-.3691.8379-.53a1.5834 1.5834 0 0 1 1.1924-.1279 1.0268 1.0268 0 0 1 .625.5127 1.3188 1.3188 0 0 1 -.3184 1.3278zm7.8672-9.0049-6.4341 6.64a2.4777 2.4777 0 0 0 -.6817-.616l6.5586-6.5182c.2139-.2139.5674-.2988.6992-.167.1528.1524.0522.4668-.1421.6612z" />
    </g>
  );
};

export default withIcon(IconBrush);
